import { createFeatureSelector, createSelector } from '@ngrx/store';

import { CANDIDATE_STATE_KEY } from '../candidate-details.constants';
import * as candidatesState from './candidates.reducer';

export const candidatesSelector = createFeatureSelector<candidatesState.ICandidatesState>(CANDIDATE_STATE_KEY);

export const candidates = createSelector(
  candidatesSelector,
  candidatesState.candidates
);

export const candidateListNavigator = createSelector(
  candidatesSelector,
  candidatesState.candidateListNavigator
);

export const organizations = createSelector(
  candidatesSelector,
  candidatesState.organizations
);

export const organizationsProcessing = createSelector(
  candidatesSelector,
  candidatesState.organizationsProcessing
);

export const researchStudies = createSelector(
  candidatesSelector,
  candidatesState.researchStudies
);

export const researchStudiesProcessing = createSelector(
  candidatesSelector,
  candidatesState.researchStudiesProcessing
);

export const selectedCandidate = createSelector(
  candidatesSelector,
  candidatesState.selectedCandidate
);

export const selectedOrganization = createSelector(
  candidatesSelector,
  candidatesState.selectedOrganization
);

export const selectedResearchStudy = createSelector(
  candidatesSelector,
  candidatesState.selectedResearchStudy
);

export const viewArchivedCandidates = createSelector(
  candidatesSelector,
  candidatesState.viewArchivedCandidates
);
